import { render, staticRenderFns } from "./edit_Column.vue?vue&type=template&id=5dd48f17&style=true"
import script from "./edit_Column.vue?vue&type=script&lang=js"
export * from "./edit_Column.vue?vue&type=script&lang=js"
import style0 from "./edit_Column.vue?vue&type=style&index=0&id=5dd48f17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports